module.exports = __webpack_public_path__ + "4c9c7f8cdb0ec4f2b867001121a24c37.png";